/**
 * ComposePreviewView (web wrapper) — 정본은 `@safetyhub/report-composer`의 동명 컴포넌트다.
 *
 * 작성 중 최종 문서 미리보기는 admin 시뮬레이션도 web 배포판과 동일하게 렌더해야 하므로
 * rc 패키지로 승격했다(2026-07-26). 앱 헤더 오프셋(useStickyChromeTop)은 web 레이아웃 지식이라
 * rc가 모른다 — 이 래퍼가 훅 값을 stickyTopOffset prop(host adapter)으로 주입해 종전과 동일하게
 * 동작한다(ComposeWritePageShell의 stickyTopOffset 배선과 동형). 그 외 동작 차이는 없다.
 */
import {
  ComposePreviewView as RcComposePreviewView,
  type ComposePreviewViewProps,
} from '@safetyhub/report-composer';
import { useStickyChromeTop } from '../../../hooks/useStickyChromeTop';

export function ComposePreviewView(props: Omit<ComposePreviewViewProps, 'stickyTopOffset'>) {
  // 앱 헤더(z-[60]) 아래에 붙도록 lg 미만 56px / lg+ 0 — 종전 내부 훅 호출과 동일 값.
  const stickyTop = useStickyChromeTop();
  return <RcComposePreviewView {...props} stickyTopOffset={stickyTop} />;
}
